import { Outlet } from 'react-router-dom';
import styles from './Viewer.module.css';

/**
 * Full-viewport layout for annotation viewer pages.
 * No topbar, no left nav — the page component owns all chrome.
 * Designed for reuse by any future full-screen viewer route.
 */
export default function ViewerLayout() {
    return (
        <div className={styles.viewerLayout}>
            <Outlet />
        </div>
    );
}
